import { render } from "./user-type-form.vue?vue&type=template&id=f1ca3932"
import script from "./user-type-form.vue?vue&type=script&lang=js"
export * from "./user-type-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__